import {UsageEvent} from '../types';
import {
    PlatformPropertyCard,
    PlatformPropertyCardCopyButtonDecorator,
    PlatformPropertyCardProperty
} from "@flexinet/ui-components";
import {Code, ScrollArea, Stack, Text, Title} from "@mantine/core";
import {BillableBadge} from "./Badges.tsx";
import {prettyPrintAttributes} from "../utils/parseAttributes.ts";

export const Profile = ({record}: { record: UsageEvent }) => {

    const identityProperties = [
        {
            label: 'ID',
            value: record.id as string,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 12,
        },
        {
            label: 'Event ID',
            value: record.eventId as string,
            decorator: (value: string) => <PlatformPropertyCardCopyButtonDecorator value={value}/>,
            span: 12,
        },
        {
            label: 'Status',
            value: <BillableBadge record={record}/>,
            span: 6,
        },
        {
            label: 'Meter Code',
            value: (record.meterCode as string) ?? '—',
            span: 6,
        },
    ] as PlatformPropertyCardProperty[];

    const attributionProperties = [
        {
            label: 'Account ID',
            value: (record.accountId as string) ?? '—',
            span: 6,
        },
        {
            label: 'Customer ID',
            value: (record.customerId as string) ?? '—',
            span: 6,
        },
        {
            label: 'Quantity',
            value: typeof record.quantity === 'number' ? String(record.quantity) : '—',
            span: 6,
        },
        {
            label: 'Customer Meter Key',
            value: (record.customerMeterKey as string) ?? '—',
            span: 6,
        },
        {
            label: 'Occurred At',
            value: record.occurredAt as string,
            formatAs: 'Timestamp',
            span: 6,
        },
        {
            label: 'Ingested At',
            value: record.receivedAt as string,
            formatAs: 'Timestamp',
            span: 6,
        },
    ] as PlatformPropertyCardProperty[];

    const attributes = prettyPrintAttributes(record.attributes);

    return (
        <Stack gap={'lg'}>
            <PlatformPropertyCard properties={identityProperties}/>
            <PlatformPropertyCard properties={attributionProperties}/>

            <Stack gap={'xs'}>
                <Title order={5}>Attributes</Title>
                {attributes
                    ? <ScrollArea.Autosize mah={400}>
                        <Code block>{attributes}</Code>
                    </ScrollArea.Autosize>
                    : <Text c={'dimmed'} size={'sm'}>No attributes on this event.</Text>}
            </Stack>
        </Stack>
    );
};
